// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import ResultImageGrid from "root/components/ResultImageGrid";
import { selectContextItems } from "../../selectors";
import bindActions, { types as ats } from "../../actions";

import "./ContextPhotos.scss";

type OwnProps = {|
	isMultiple: boolean,
	allowSelect?: boolean,
	context: number,
	contextId?: string,
|};

type Props = {
	...OwnProps,
	inProgress: boolean,
	selected: string[],
	items: Object[],
	cursor: string | null;
	[string]: Function,
};

class ContextPhotos extends Component<Props> {

	static defaultProps = {
		allowSelect: true,
	};

	componentDidMount() {
		this.props[ats.GET_CONTEXT_PHOTOS](this.props.context, { id: this.props.contextId });
	}

	onSelection = (id: string, e: MouseEvent) => {
		if (this.props.selectionAction) {
			this.props.selectionAction(id);
		} else {
			this.props[ats.SET_FILE_SELECTION]({
				id,
				e,
				multiple: this.props.isMultiple,
			});
		}
	};

	onLoadMore = () => {
		if (!this.props.inProgress) {
			this.props[ats.GET_CONTEXT_PHOTOS](this.props.context, {
				id: this.props.contextId,
				extend: true,
			});
		}
	};

	renderPhotos() {
		return <ResultImageGrid
			images={this.props.items}
			selected={this.props.selected}
			isMultiple={this.props.isMultiple}
			allowSelect={this.props.allowSelect}
			showProgressIndicator={this.props.inProgress}
			selectionAction={this.onSelection}
			onLoadMore={this.onLoadMore}
			hasMore={!!this.props.cursor}/>;
	}

	render() {
		return <div className={`context-items photos-${this.props.context}`}>
			{this.renderPhotos()}
		</div>;
	}
}

export default connect<Props, OwnProps, _, _, _, _>(
	selectContextItems,
	bindActions,
)(ContextPhotos);
